import React, { useMemo } from "react"
import { useLocation } from "react-router-dom"
import LandingTemplate from "./LandingTemplate.jsx"
import { LANDING_PAGES } from "./landingPages.js"

export default function LandingPage() {
  const location = useLocation()

  const page = useMemo(() => {
    const match = LANDING_PAGES.find(
      (p) => p.path === location.pathname
    )
    return match || null
  }, [location.pathname])

  return <LandingTemplate page={page} />
}